import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const NewReportIcon = ({
  width = '25',
  height = '25',
  color = '#96A2C2'
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    style={{
      fill: color,
      width: width,
      height: height
    }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="1 1 20 20"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.66299 2H13.0849L19.2626 8.03774V20.337C19.2626 21.2555 18.518 22 17.5996 22H5.66299C4.74455 22 4 21.2555 4 20.337V3.66299C4 2.74455 4.74455 2 5.66299 2ZM16.2818 9.4693C16.2818 8.88729 15.81 8.41547 15.228 8.41547C14.6459 8.41547 14.1741 8.88729 14.1741 9.4693L14.1741 19.4371C14.1741 20.0191 14.6459 20.4909 15.228 20.4909C15.81 20.4909 16.2818 20.0191 16.2818 19.4371L16.2818 9.4693ZM11.5957 11.434C12.1777 11.434 12.6495 11.9058 12.6495 12.4878V19.4368C12.6495 20.0188 12.1777 20.4906 11.5957 20.4906C11.0136 20.4906 10.5418 20.0188 10.5418 19.4368L10.5418 12.4878C10.5418 11.9058 11.0136 11.434 11.5957 11.434ZM9.01411 14.7518C9.01411 14.1698 8.5423 13.698 7.96028 13.698C7.37827 13.698 6.90645 14.1698 6.90645 14.7518L6.90645 19.4366C6.90645 20.0186 7.37827 20.4904 7.96028 20.4904C8.5423 20.4904 9.01411 20.0186 9.01411 19.4366L9.01411 14.7518Z"
    />
  </IconSvg>
)

export default NewReportIcon
